import React, { useContext } from 'react';
import { TileKitContext } from '../TileKit/TileKit';
import './TrimMileage.scss';

const TrimMileage = () => {
  const { vehicle } = useContext(TileKitContext);
  const trim = vehicle?.trim;
  const mileage = Number(vehicle?.mileage || 0).toLocaleString();

  if (!vehicle?.vehicleId) {
    return (
      <div className="pb-12">
        <div className="skeleton-trim" />
      </div>
    );
  }

  return (
    <div className="trim-mileage" data-qa="trim-mileage">
      <span>{trim}</span> • <span>{mileage} miles</span>
    </div>
  );
};

export default TrimMileage;
